










import { Component, Vue, Ref } from 'vue-property-decorator';
import {
  PersonalInfo, AuthInfo, EmailInfo, PhoneInfo, PasswordInfo,
} from '@/BasicInfo';
import cardSide1 from 'assets/userCenter/accountInfo/card-side1.png';
import cardSide2 from 'assets/userCenter/accountInfo/card-side2.png';
import cardWait from 'assets/userCenter/accountInfo/card-wait.png';
import cardFail from 'assets/userCenter/accountInfo/card-fail.png';
import { getUserAccountDetail } from 'service/api';

const industry: string[] = [];

interface Info {
  userName: string;
  idCard: string;
  idCardType: string;
  pictureFacade: string;
  pictureObverse: string;
}

interface PersonalComponent {
  initLocation: () => void;
}

@Component({
  components: {
    PersonalInfo,
    AuthInfo,
    EmailInfo,
    PhoneInfo,
    PasswordInfo,
  },
})
export default class BasicInformation extends Vue {
  @Ref('personal') personal!: PersonalInfo & PersonalComponent;

  authentication = 0;

  authInfo = {
    userName: '',
    idCard: '',
    idCardType: '1',
    pictureFacade: cardSide1,
    pictureObverse: cardSide2,
  };

  personalInfo = {
    userName: '',
    garden: '',
    province: '',
    city: '',
    downtown: '',
    industry,
  };

  email = '';

  phone = '';

  async getUserInfo() {
    const res: any = await getUserAccountDetail();
    if (res.state) {
      const userInfo = res.data.rows;
      const cardInfo = res.data.idCardInfo;
      this.personalInfo = {
        userName: userInfo.userName,
        province: userInfo.province ? String(userInfo.province) : '',
        city: userInfo.city ? String(userInfo.city) : '',
        downtown: userInfo.downtown ? String(userInfo.downtown) : '',
        garden: userInfo.garden ? String(userInfo.garden) : '',
        industry: userInfo.industry ? userInfo.industry.split(/\s+/).filter((id: string) => !!id) : [],
      };
      this.personal.initLocation();
      this.authentication = cardInfo.del_flag || 4;
      const authInfo: Info = {
        userName: '',
        idCard: '',
        idCardType: '1',
        pictureFacade: cardSide1,
        pictureObverse: cardSide2,
      };
      if (cardInfo.del_flag === 1) {
        authInfo.pictureFacade = cardWait;
        authInfo.pictureObverse = cardWait;
      } else if (cardInfo.del_flag === 2) {
        authInfo.pictureFacade = cardFail;
        authInfo.pictureObverse = cardFail;
      } else if (cardInfo.del_flag === 0) {
        authInfo.pictureFacade = cardInfo.picture_facade;
        authInfo.pictureObverse = cardInfo.picture_obverse;
      }
      authInfo.userName = cardInfo.name || '';
      authInfo.idCard = cardInfo.number || '';
      authInfo.idCardType = cardInfo.type || '1';
      this.authInfo = { ...authInfo };
      this.email = userInfo.mailAddress || '';
      this.phone = userInfo.mobilePhone || '';
      this.$store.commit('SET_USER', {
        userName: userInfo.userName,
        avatar: userInfo.avatar,
        userId: userInfo.id,
        enterpriseId: userInfo.enterpriseId,
        organizationId: userInfo.organizationId,
        platformId: userInfo.platformId,
      });
    }
  }

  mounted() {
    this.getUserInfo();
  }
}
